module.exports = __webpack_public_path__ + "img/energySaving.78ea1fca.png";